import React, { useState } from 'react';
import { datetime } from '../../util/library/datetime2';
import { selectTenantId } from '../../util/store/selectors';
import { getStore } from '../../util/store/store';
import { getSetting } from '../../util/varibles/defaultSetting';
import { VesselSetting } from '../../util/varibles/userSetting';
import VesselOverviewContent from './VesselOverviewContent';
import { VesselOverviewProvider } from './VesselOverviewContext';

const VesselOverview: React.FC = () => {
    const [duration] = useState<[number, number] | undefined>(() => {
        const now = datetime();
        if (`${selectTenantId(getStore())}` !== '41' || now.month() !== 8 || now.year() !== 2026) {
            return undefined;
        }

        return [now.startOf('month').valueOf(), now.endOf('month').valueOf()];
    });
    const [vesselFilter] = useState<string[]>(() => getSetting(
        getStore().login.user.setting,
        VesselSetting.VESSEL_FILTER,
    ));

    return <VesselOverviewProvider vesselFilter={vesselFilter} {...(duration && { duration })}>
        <VesselOverviewContent />
    </VesselOverviewProvider>;
};

export default VesselOverview;
